import React from "react";
import { css } from "@emotion/css";

interface SuccessBannerProps {
  title: string;
  message: string;
}

export const SuccessBanner: React.FC<SuccessBannerProps> = ({ title, message }) => (
  <div className={successBannerStyle}>
    <div className={successIconStyle}>✅</div>
    <div className={successContentStyle}>
      <h2 className={successTitleStyle}>{title}</h2>
      <p className={successMessageStyle}>{message}</p>
    </div>
  </div>
);

const successBannerStyle = css`
  background: rgba(76, 175, 80, 0.1);
  border: 1px solid rgba(76, 175, 80, 0.3);
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  gap: 16px;
`;

const successIconStyle = css`
  font-size: 24px;
`;

const successContentStyle = css`
  flex: 1;
`;

const successTitleStyle = css`
  font-size: 18px;
  font-weight: 600;
  color: #4caf50;
  margin: 0 0 8px 0;
`;

const successMessageStyle = css`
  font-size: 14px;
  color: #adadad;
  margin: 0;
`; 